import { orchestrator } from 'satcheljs';
import { updateCollapsedAllDayWellHeight } from '../actions/updateCollapsedAllDayWellHeight';
import {
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
    CalendarSurfaceOptions,
    getOptionsForFeature,
} from 'owa-outlook-service-options';

const SCROLL_DELAY = 3000;
let onScrollTimeoutTask = null;

orchestrator(updateCollapsedAllDayWellHeight, actionMessage => {
    if (onScrollTimeoutTask) {
        clearTimeout(onScrollTimeoutTask);
    }
    onScrollTimeoutTask = setTimeout(() => {
        const userOptions = getOptionsForFeature<CalendarSurfaceOptions>(
            OwsOptionsFeatureType.CalendarSurfaceOptions
        );
        onScrollTimeoutTask = null;

        lazyCreateOrUpdateOptionsForFeature.importAndExecute(
            OwsOptionsFeatureType.CalendarSurfaceOptions,
            {
                ...userOptions,
                allDayWellHeight: actionMessage.newValue,
            } as CalendarSurfaceOptions
        );
    }, SCROLL_DELAY);
});
